import { store, authActions } from '_store';
import { jwtDecode } from 'jwt-decode';


function decodeToken(token) {
    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Failed to decode token:', error);
        return {};
    }
}
export function isTokenExpired() {
    const auth = JSON.parse(localStorage.getItem('auth'));
    if (auth && auth.token) {
        const decodedToken = decodeToken(auth.token);
        const expirationTime = decodedToken.exp * 1000;
        return new Date().getTime() > expirationTime;
    }
    return false;
}

// Function to handle automatic logout if token is expired
export function handleTokenExpiration() {
    if (isTokenExpired()) {
        localStorage.removeItem('auth');
        window.location.href = '/'; // Redirect to login page
    }
}

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
            requestOptions.body = JSON.stringify(body);
        }
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const token = authToken();
    const isLoggedIn = !!token;
    const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${token}` };
    } else {
        return {};
    }
}

function authToken() {
    const auth = JSON.parse(localStorage.getItem('auth'));
    return auth?.token;
}

let hasLoggedOut = false;
async function handleResponse(response) {
    const isJson = response.headers?.get('content-type')?.includes('application/json');
    const data = isJson ? await response.json() : null;

    if (!response.ok) {
        if ([401, 403].includes(response.status) && authToken()) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            const logout = () => store.dispatch(authActions.logout());
            logout();
        }

        // if (!response.ok) {
        //     if (response.status === 401 || response.status === 403 || isTokenExpired()) {
        //         // Handle token expiration
        //         localStorage.removeItem('auth');
        //         window.location.href = '/account/login'; // Redirect to login page
        //     }        

        // Get error message from body or default to response status
        const error = data?.msg || data?.message || data?.error || response.statusText;
        return Promise.reject(error);
 
    }

    return data;
}